<template>
    <div class="examineReceive">
        <Box title="科室验收">
            <FacilityDetails :data="EquipmentInfo"/>
            <RepairsDetails :data="MaintainInfo" :RepairFee="Number(EquipmentInfo.RepairFee)+Number(EquipmentInfo.PartsFee)"/>
            <div class="infoBox record">
                <p class="title">报修图片</p>
                <img v-for="(item,index) in RepairPhotos" :src='item' @click="PhotoShow(1,index)"/>
            </div>
            <Audio :AudioExternal='MaintainInfo.AudioUrl'/>
            <div class="infoBox record">
                <p class="title">维修情况</p>
                 <textarea readonly="true" rows="6" v-model="RepairRemark"></textarea>
            </div>

            <div class="infoBox record">
                <p class="title">维修图片</p>
                <img v-for="(item,index) in MaintainPhotos" :src='item' @click="PhotoShow(2,index)"/>
            </div>

            <div class="infoBox receive">
                <p class="title">验收信息</p>

                <div class="receiveBox" v-for="(item,index) in evaluate">
                    <div>
                        <div>{{item.UserName}}</div>
                        <div>{{item.UserType=='0'?'维修工程师':'协助工程师'}}</div>
                    </div>
                    <div class="receiveItems" v-for="(ChildItem,ChildIndex) in item.Content">
                       <span>{{ChildItem.type}}</span>
                        <Check @change="value => evaluate[index].Content[ChildIndex].score = value"/>
                    </div>
                </div>

                <p class="repairTitle">是否修复</p>
                <div class="repairBox">
                    <div :class="repair ? 'action' : ''" @click="repair = true">已修复</div>
                    <div :class="!repair ? 'action' : ''" @click="repair = false">未修复</div>
                </div>
                <Field title="停机时间" type="text" :text="EquipmentInfo.RepairDate"/>
                <Field title="停机时长" type="text" :text="downtime"/>
                <Field title="验收建议" placeholder="请输入" type="textarea" @onMessage="value => suggest = value"/>
            </div>
        </Box>
        <Footer button="验收" @change="change"/>
    </div>
</template>

<script>
    import Audio from '../../components/Audio/AudioDefault.vue'
    import Box from '../../components/commonBox/commonBox'
    import FacilityDetails from '../../components/facilityDetails/facilityDetails'
    import RepairsDetails from '../../components/repairsDetails/repairsDetails'
    import Footer from '../../components/footer/footer'
    import ImgModule from '../../components/imgModule/imgModule'
    import Check from '../../components/check/check'
    import Field from '../../components/field/field'
    import {ImagePreview} from 'vant'

    export default {
        name: 'ExamineReceive',
        components: {
            Audio,
            Box,
            FacilityDetails,
            Footer,
            RepairsDetails,
            ImgModule,
            Check,
            Field,
            [ImagePreview.name]:ImagePreview
        },
        data() {
            return {
                RepairRemark:this.$route.params.item.ReResult,
                EquipmentInfo:this.$route.params.item,
                MaintainInfo:{},
                PJ: [],
                RY: [],
                TP:[],
                evaluate: [//评价

                ],
                repair: true,//  是否已修复
                downtime: 0,//  停机时间
                suggest: null,//  验收建议
                RepairPhotos:[],//报修图片
                MaintainPhotos:[],//维修图片
            }
        },
        mounted(){
            this.loadDataDefault();
        },
        methods: {
            change() {
                //处理 评价
                var Attitude="";//服务态度
                var TechnicalLevel="";//技术水平
                var AgingResponse="";//响应时效
                var i=1;
                for(let item of this.evaluate){
                    Attitude+=`${item.UserCode}:${item.Content.find(x=>x.type=='服务态度').score}${i==this.evaluate.length?'':','}`;
                    TechnicalLevel+=`${item.UserCode}:${item.Content.find(x=>x.type=='技术水平').score}${i==this.evaluate.length?'':','}`;
                    AgingResponse+=`${item.UserCode}:${item.Content.find(x=>x.type=='响应时效').score}${i==this.evaluate.length?'':','}`;
                    i++;
                }

                this.$post('api/Approval/DepartmentApproval',{
                    RepairNo:this.EquipmentInfo.RepairOrder,
                    ApprovalState:'Y',
                    ApprovalUserCode:this.$UserInfo.UserId,
                    IsComplete:null,
                    Satisfaction:null,
                    Proposal:this.suggest,//验收建议
                    Attitude:Attitude,
                    TechnicalLevel:TechnicalLevel,
                    AgingResponse:AgingResponse,
                    DownTime:this.DownTime,//停机时长
                    Store:this.$UserInfo.StoreCode,
                    IsRepair:this.repair?'1':'0'
                }).then(result=>{
                    this.$Toast(result.Msg);
                    if(result.Status){
                         this.$Bus.$emit('Message',this.EquipmentInfo.RepairOrder);
                        setTimeout(x=>{
                            this.$router.go(-1);
                        },2000);
                    }
                })
            },loadDataDefault(){//获取维修信息
                this.$get('api/Repair/GetRepairInfoOne',{
                    RepairNo:this.EquipmentInfo.RepairOrder,
                    Store:this.$UserInfo.StoreCode,
                    Token:'1235'
                }).then(result=>{
                    this.downtime=((new Date()-new Date(this.EquipmentInfo.RepairDate.replace(/-/g, "/")))/ 1000 / 60 /60).toFixed(2)+"h";
                    this.MaintainInfo=result.WX;//维修总金额
                    this.MaintainInfo.RepairFee=this.EquipmentInfo.PartsFee+this.EquipmentInfo.RepairFee;
                    this.RY=result.RY;

                    for(let i=0;i<result.RY.length;i++){
                        var num={
                            UserCode:result.RY[i].UserCode,
                            UserName:result.RY[i].UserName,
                            UserType:result.RY[i].UserType,
                            Content:[{
                                type:'服务态度',score:'1'
                            },{
                                type:'技术水平',score:'1'
                            },{
                                type:'响应时效',score:'1'
                            }]
                        }
                        this.evaluate.push(num);
                    }
                    //报修图片和维修图片
                    this.RepairPhotos=result.WX.Images.split(',').filter((x)=>{
                        return !!x;
                    });
                    this.MaintainPhotos=result.TP.map((x)=>{
                        return x.PicUrl;
                    })
                })

            },RepairDefault(){
                let ImageArray=[];//图片信息
                this.$get('api/Repair/MaintenanceOther',{
                    WXDH:this.EquipmentInfo.RepairOrder,
                    JCHH:'1'
                }).then(result=>{
                    result.accessory.forEach(function(item,index){
                        ImageArray.push({
                            HH:item.HH,
                            url:item.Repath,
                            Repath:item.WJLJ
                        });
                    })
                    this.$Bus.$emit('YSRKDelete',ImageArray);//图片
                })
            },PhotoShow(type,index){
                ImagePreview({
                    images:type==1? this.RepairPhotos:this.MaintainPhotos,
                    startPosition: index,
                    swipeDuration: 500,
                    closeOnPopstate: true,
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .examineReceive{
        padding-bottom: 112px;
    }
    .record{
        p:last-child{
            font-size: 28px;
            color: #858585;
        }
        textarea{
            color: #666666;
            font-size: 3.65vw;
        }

    }
    .receiveBox{
        border-bottom: 2px solid #F3F3F3;
        .receiveItems{
            display: flex;
            margin-bottom: 38px;
            &>span{
                color: #858585;
                font-size: 28px;
                margin-right: 32px;
            }
        }
        &>div{
            &:first-child{
                width: 100%;
                &>div{
                 display: inline-block;
                 &:first-child{
                     width: 78%;
                 }
                 &:last-child{
                     border-radius: 1em;
                     text-align: center;
                     width: 20%;
                     font-size: 2vw;
                     color:#FFFFFF;
                     background-color:#FE5D09 ;
                 }
                }
            }
        }

    }
    .repairTitle{
         font-size: 28px;
        color: $TEXT-DARK-COLOR;
        margin-top: 30px;
    }
    .repairBox{
        display: flex;
        margin-top: 28px;
        padding-bottom: 30px;
        border-bottom: 2px solid #F3F3F3;
        div{
            width: 148px;
            height: 76px;
            border-radius: 8px;
            background: #f3f3f3;
            color: #858585;
            line-height: 76px;
            text-align: center;
            font-size: 30px;
            margin-right: 24px;
        }
        .action{
            background: $THEME-COLOR;
            color: #fff;
        }
    }
    .receive{
        padding-bottom: 0;
    }
    .infoBox img{
        width: 106px;
        height: 106px;
        margin: 0 10px;
    }

</style>



// WEBPACK FOOTER //
// src/page/examineReceive/examineReceive.vue